const types = {
	open: 'open',
	click: 'click',
	bounce: 'bounce',
	unsub: 'unsub'
};

const locale = {
	ru: types,
	en: types,
	uk: types,
	de: types,
	vi: types,
	th: types
};

module.exports = {
	enum: types,
	locale: locale
};



// WEBPACK FOOTER //
// ./enums/mailing-events.js